const amountTaxRate = (totalAmount: number, tax: number) => {
    if (tax < 0) {
        return 0;
    }
    const taxRate = totalAmount * (tax / 100);
    return taxRate;

}
const calculateBonus = (bottleCost: number, bonusPercent: number) => {
    return (bonusPercent / 100) * bottleCost
}
export { amountTaxRate, calculateBonus }